import { BusinessUnitsComponent } from './BusinessUnits.types';
import { Box, Flexbox, Tooltip, Typography } from '@hiiretail/synergy-ui';
import {
  BusinessUnit,
  BusinessUnitsContainer,
  StyledButton,
  StyledCancelIcon,
  StyledLockIcon,
  StyledPlusIcon,
} from './BusinessUnits.styles';
import { useParams } from 'react-router-dom';

export const BusinessUnits: BusinessUnitsComponent = ({
  role: { roleId, isCustom, bindings: businessUnits, fixedBindings },
  setBuToDelete,
  openAddBusinessUnitModal,
}) => {
  const { id } = useParams<{ id: string }>();
  const handleRemoveBusinessUnit = (businessUnit: string) => () => {
    const newBusinessUnits = businessUnits.filter((i) => i !== businessUnit);
    setBuToDelete({
      roleId,
      groupId: id as string,
      bindings: newBusinessUnits,
      isCustom,
    });
  };

  return (
    <BusinessUnitsContainer container item flex="1 1 auto">
      {fixedBindings?.map((fixedBinding) => (
        <BusinessUnit container item key={fixedBinding}>
          <Tooltip title="Fixed binding: This binding is fixed (locked) on the role level, it can not be removed.">
            <StyledButton type="button">
              <StyledLockIcon size="sm" />
            </StyledButton>
          </Tooltip>
          <Box ml={1}>{fixedBinding}</Box>
        </BusinessUnit>
      ))}
      {businessUnits.length ? (
        businessUnits.map((businessUnit) => (
          <BusinessUnit container item key={businessUnit}>
            <Box mr={1}>{businessUnit}</Box>
            <StyledButton
              type="button"
              onClick={handleRemoveBusinessUnit(businessUnit)}
              data-testid="remove-business-unit"
            >
              <StyledCancelIcon size="sm" />
            </StyledButton>
          </BusinessUnit>
        ))
      ) : (
        <Flexbox container item alignItems="center">
          <Typography variant="body2">No resources</Typography>
        </Flexbox>
      )}
      <StyledButton
        type="button"
        disabled={businessUnits.length >= 10}
        onClick={openAddBusinessUnitModal}
        data-testid="add-business-unit"
      >
        <StyledPlusIcon size="md" />
      </StyledButton>
    </BusinessUnitsContainer>
  );
};
